import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ImagePlaceholder } from '../ui/ImagePlaceholder';
const PAIN_POINTS = [{
  emoji: '🫧',
  title: 'The Bubble Struggle',
  desc: 'My resin keeps coming out with bubbles no matter what I try'
}, {
  emoji: '😩',
  title: 'The Sticky Mess',
  desc: 'I followed the tutorial perfectly and it still went sticky'
}, {
  emoji: '💸',
  title: 'Wasted Money',
  desc: "I've spent hundreds on supplies and have nothing to show for it"
}, {
  emoji: '😶',
  title: 'Feeling Left Behind',
  desc: "Everyone else makes it look so easy. Why can't I do it?"
}, {
  emoji: '🎲',
  title: 'The Pour Lottery',
  desc: "Every pour feels like a lottery — I never know if it'll work"
}, {
  emoji: '📺',
  title: 'Tutorial Overload',
  desc: "I've watched hours of YouTube and I'm more confused than ever"
}];
export function PainPoints() {
  return <section className="w-full px-4 md:px-8 max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-191">
      <FadeIn data-id="element-192">
        <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-193">
          Sound Familiar?
        </span>
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-cream mb-6" data-id="element-194">
          You're not alone.
        </h2>
        <p className="font-lato text-lg text-cream/80 max-w-2xl mx-auto mb-16" data-id="element-195">
          This is exactly what our students felt before they found this system:
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full mb-16" data-id="element-196">
        {PAIN_POINTS.map((point, index) => <FadeIn key={index} delay={index * 100} direction="up" data-id="element-197">
            <div className="bg-darkCard border border-darkBorder rounded-xl p-6 md:p-8 text-left transition-all duration-300 hover:-translate-y-1 hover:border-amber/50 group" data-id="element-198">
              <div className="flex items-start gap-4" data-id="element-199">
                <span className="text-3xl md:text-4xl" aria-hidden="true" data-id="element-200">
                  {point.emoji}
                </span>
                <div data-id="element-201">
                  <h3 className="font-lato font-bold text-cream text-lg mb-2 group-hover:text-amber transition-colors" data-id="element-202">
                    {point.title}
                  </h3>
                  <p className="font-lato text-cream/70 leading-relaxed" data-id="element-203">
                    "{point.desc}"
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={150} className="w-full mb-16" data-id="element-204">
        <img src="https://cdn.magicpatterns.com/uploads/6Uz2G8MQYFaY7QsffxD9Sw/BEFORE.jpg" alt="Failed resin piece with bubbles, sticky texture, and ruined mold" className="w-full max-w-lg mx-auto aspect-[4/3] object-cover rounded-lg" data-id="element-205" />
        <p className="italic text-sm text-cream/50 text-center mt-3 font-lato" data-id="element-206">
          Sound familiar? This is what happens without a system.
        </p>
      </FadeIn>

      <FadeIn delay={200} className="w-full max-w-3xl" data-id="element-207">
        <div className="bg-darkCard border-l-4 border-amber p-6 md:p-8 rounded-r-xl shadow-lg relative overflow-hidden" data-id="element-208">
          <div className="absolute top-0 right-0 text-amber/5 text-9xl font-playfair leading-none -mt-4 -mr-4 select-none pointer-events-none" data-id="element-209">
            "
          </div>
          <p className="font-playfair italic text-xl md:text-2xl text-cream/90 relative z-10 mb-4" data-id="element-210">
            "There has to be a right way to do this. I just need someone to
            explain it properly."
          </p>
          <p className="font-lato text-amber/80 text-sm uppercase tracking-wider font-bold" data-id="element-211">
            — Real words from our students
          </p>
        </div>
      </FadeIn>
    </section>;
}